import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

import { EvrideoCommonModule } from '../common/evrideo-common.module';
import { MamExplorerContainerComponent } from './mam-explorer-container/mam-explorer-container.component';
import { MamExplorerToolbarComponent } from './mam-explorer-toolbar/mam-explorer-toolbar.component';
import { MamExplorerActionsCellComponent } from './mam-explorer-actions-cell/mam-explorer-actions-cell.component';
import { MamExplorerStatusCellComponent } from './mam-explorer-status-cell/mam-explorer-status-cell.component';
import { MamExplorerNameCellComponent } from './mam-explorer-name-cell/mam-explorer-name-cell.component';
import { MamExplorerSelectAllHeaderComponent } from './mam-explorer-select-all-header/mam-explorer-select-all-header.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AgGridModule,
    EvrideoCommonModule,
  ],
  declarations: [
    MamExplorerContainerComponent,
    MamExplorerToolbarComponent,
    MamExplorerActionsCellComponent,
    MamExplorerStatusCellComponent,
    MamExplorerNameCellComponent,
    MamExplorerSelectAllHeaderComponent,
  ],
  exports: [MamExplorerContainerComponent],
})
export class MamExplorerModule {}
